export default __webpack_public_path__ + "static/media/Ballroll_00318.193c19a3.png";